import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, of, catchError, tap, switchMap } from 'rxjs';

import { ApiClientService } from '@tablesready/api-client';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Injectable()
export class VerifyEmailService {
  private readonly basePath = '/verify';

  constructor(
    private readonly http: ApiClientService,
    private readonly router: Router,
    private readonly alertsService: AlertsService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {}

  verifyEmail(uuid: string): Observable<any> {
    return this.http.get(`${this.basePath}/${uuid}`)
      .pipe(
        catchError(err => {
          this.alertsService.addError('error verifying email');
          return this.router.navigateByUrl(`/login?verify=${err.code}`);
        }),
        switchMap(() => this.authRestaurantService.load()),
        catchError(() => of(null)),
        tap(() => {
          this.alertsService.addSuccess('your email verified successfully', 'Verified:');
          this.router.navigateByUrl('/login?verify=success');
        }),
      );
  }
}
